export enum FunctionType {
  /** @see DesignObject has its own script on its config that should be used. */
  custom = 'CUSTOM',
  /**
   * @see DesignObject uses a reuseable @see DesignFunction.
   *
   * @note Used for @see CustomNodeModel.
   */
  reuseable = 'REUSEABLE'
}
